// IPDATA API
export const IP_BASE_URL = 'https://api.ipdata.co?api-key=';

// GEO.IPIFY API
export const IP_INFO_BASE_URL = 'https://geo.ipify.org/api/v1?apiKey=';
